import { Link, useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { newsSorted, getNews } from "../lib/news";

const fmt = (d) => new Date(d + "T00:00:00").toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

export function NewsIndex() {
  useEffect(() => { document.title = "News · Philadelphia Freeway"; }, []);
  const items = newsSorted();
  return (
    <div className="App bg-black min-h-screen text-white flex flex-col">
      <Navbar />
      <main className="flex-1 px-4 md:px-10 max-w-[1400px] mx-auto pt-28 md:pt-36 pb-20 md:pb-28 w-full">
        <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#F4C10A] mb-3">Philadelphia Freeway · FTA</div>
        <h1 className="font-wide uppercase text-5xl md:text-7xl leading-[0.95]">News</h1>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-10">
          {items.map((n) => (
            <Link key={n.slug} to={`/news/${n.slug}`} data-testid={`news-item-${n.slug}`} className="group block">
              <div className="relative aspect-[4/3] bg-neutral-900 overflow-hidden">
                <img src={n.hero} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"/>
              </div>
              <div className="mt-4">
                <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/50">{fmt(n.date)}</div>
                <h2 className="mt-2 font-wide uppercase text-2xl md:text-3xl leading-tight group-hover:text-[#F4C10A]">{n.title}</h2>
                <p className="mt-2 font-body text-white/70 text-sm md:text-base leading-relaxed line-clamp-3">{n.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}

export function NewsArticle() {
  const { slug } = useParams();
  const nav = useNavigate();
  const n = getNews(slug);
  useEffect(() => { if (!n) nav("/news"); else document.title = `${n.title} · News`; }, [n, nav]);
  if (!n) return null;
  return (
    <div className="App bg-black min-h-screen text-white flex flex-col">
      <Navbar />
      <main className="flex-1 px-4 md:px-10 max-w-4xl mx-auto pt-28 md:pt-36 pb-20 md:pb-28 w-full">
        <Link to="/news" className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.3em] uppercase text-white/60 hover:text-[#F4C10A] mb-8"><ArrowLeft className="w-4 h-4"/> All News</Link>
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-white/50 mb-3">
          {fmt(n.date)}{n.location ? <span className="text-white/30"> · {n.location}</span> : null}
        </div>
        <h1 data-testid="news-article-title" className="font-wide uppercase text-4xl sm:text-5xl md:text-6xl leading-[0.95]">{n.title}</h1>
        <div className="mt-8 md:mt-10">
          <img src={n.hero} alt="" className="w-full h-auto object-cover"/>
        </div>
        <div className="mt-8 md:mt-10 space-y-5 font-body text-white/85 text-base md:text-lg leading-relaxed">
          {n.body.map((p, i) => <p key={i}>{p}</p>)}
        </div>
        {n.images.length > 1 && (
          <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-4">
            {n.images.slice(1).map((src, i) => <img key={i} src={src} alt="" loading="lazy" className="w-full h-auto object-cover"/>)}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
